<template>
    <div class="container">
        <div class="filter-wrp bg-primary-gray">
            <div class="form-row ">
            <div class="col-md-3 form-group" >
                    <label :placeholder='$t("Title")' for="txtTitle">{{$t("Title")}}</label>
                    <input type="title" class="form-control"
                           id="txtTitle" name="txtTitle" maxlength="256"
                           v-model="searchModel.title"> 
                </div>
                <div class="col-md-3 form-group">
                    <label :placeholder='$t("Number")' for="txtNumber">{{$t("Number")}}</label>
                    <input type="number" class="form-control"
                           id="txtNumber" name="txtNumber"
                           v-model="searchModel.number"> 
                     <div class="text-danger" v-if="InvalidNumber">
                        <span>{{$t("InvalidNumber")}}</span>
                    </div>
                </div>
                <div class="col-md-3 form-group">
                    <label :placeholder='$t("YearFrom")' for="txtYearFrom">{{$t("From")}}</label>
                    <input type="text" readonly class="form-control" id="YearFrom" v-model="searchModel.yearFrom" :placeholder='$t("From")'>
                    <div class="text-danger" v-if="DateFromGreaterThanTo">
                        <span>{{$t("InvalidDate")}}</span>
                    </div>
                </div>
                <div class="col-md-3 form-group">
                    <label :placeholder='$t("YearTo")' for="txtYearTo">{{$t("To")}}</label>
                    <input type="text" readonly class="form-control" id="YearTo" v-model="searchModel.yearTo" :placeholder='$t("To")'>
                </div>
                <div class="col-md-3 form-group">
                    <label :placeholder='$t("Type")' for="Type">{{$t("LawType")}}</label>
                    <select v-model="searchModel.type" class="form-control" id="Type" placeholder="Type">
                        <option value="">{{$t("SelectAll")}}</option>
                        <option v-for="item in searchLookups" :value="item.id">{{item.title}}</option>
                    </select>
                </div>   

                   <div class="col-md-3 form-group">
                    <label :placeholder='$t("Field")' for="Field">{{$t("LawField")}}</label>
                    <select v-model="searchModel.field" class="form-control" id="Field" placeholder="Field">
                        <option value="">{{$t("SelectAll")}}</option>
                        <option v-for="item in lawFieldsLookups" :value="item.id">{{item.title}}</option>
                    </select>
                </div>  

            </div>
            <div class="d-flex justify-content-end mt-3">
               
                    <button class="btn rounded-0 bg-primary text-white border-0 mx-3" type="button" @click="onFilter()">{{$t("Search")}}</button>
                    <button class="btn rounded-0 bg-primary text-white border-0" type="button" @click="onReset()">{{$t("Reset")}}</button>
                
            </div>
        </div>
    </div>
</template>


<script>

    import DocumentListingModel from "./DocumentListingModel";
    export default {
        name: "DocumentListingMainFilters",
        data: function () {
            return {
                DateFromGreaterThanTo : false,
                InvalidNumber:false,
                searchLookups:  window.searchLookups.lawTypesLookups,
                lawFieldsLookups:  window.searchLookups.lawFieldsLookups,

                searchModel: window.searchModel ? window.searchModel : (window.searchModel = new DocumentListingModel(this.$i18n, this.$http, window.searchLookups, this.$router)),
            };
        },
        mounted () 
        {
            $(window).on('load', ()=>{
                $("#YearFrom").datepicker({
                    format: "yyyy",
                    viewMode: "years", 
                    minViewMode: "years",
                    
                }).on('changeDate', (ev)=> {
                    if(ev.date != null){
                    this.searchModel.yearFrom = ev.date.getFullYear();
                    }
                    else{
                         this.searchModel.yearFrom ="";
                    }
                    });
                 $("#YearTo").datepicker({
                    format: "yyyy",
                    viewMode: "years", 
                    minViewMode: "years"
                }).on('changeDate', (ev)=> {
                    if(ev.date != null){
                         this.searchModel.yearTo = ev.date.getFullYear();
                    }
                    else{
                         this.searchModel.yearTo ="";
                    }
                    });
            });
        },
        updated: function () {
            //var _this = this;

           // this.searchModel.onUpdated();
        },
        methods: {
            textFunc: function () {
            },
            onFilter: function () {
                if(parseInt(this.searchModel.yearFrom) >parseInt(this.searchModel.yearTo) ){
                    this.DateFromGreaterThanTo = true;
                    return;
                }
                var reg_numbers = /^[\u0660-\u06690-9 ]+$/;
                if((this.searchModel.number.length >0 && reg_numbers.test(this.searchModel.number) == false )||
                 this.searchModel.number > 999999 || this.searchModel.number< 0){
                    this.InvalidNumber = true;
                    return;
                }
              return this.searchModel.onFilter();
            },
             onReset: function () {
              return this.searchModel.onReset();
            },
           // onSort: function (sortId) {
            //  return this.searchModel.onSort(sortId);
           // },
        },
        components: {
           
        }
    }
</script>
